import Scriba from 'react-scriba';

export class DataAgence {

    static _chargementAgencePerimetreEiffage = (idRegion, filtreSurMonPerimetre) => {
        const objet = { idRegion, filtreSurMonPerimetre };
        /* YD : 20230224 : Injection dependance AgenceMetier */
        const url = "api/v2/Liste/ListeDesAGENCES";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};
